// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonToTop_button__kufII","hideButton":"ButtonToTop_hideButton__RlIu4","icon":"ButtonToTop_icon__aLgpV"};